import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    nowProcessingBidWithId: null,
    fetched: false,
    bids: [],
    bid:{},
    itemsTotalCount: null,
    search: "",
    stagesForSearch: "-1", //стадии заявок по которым нужно фильтровать заявки
    savingInProgress: false,
    period: {
      from: null,
      to: null,
    },
    tableOptions: {
      page: 1,
      last_page: 1,
      itemsPerPage: 10,
      sortBy: ["id"],
      sortDesc: [true],
      groupBy: [],
      groupDesc: [],
      mustSort: false,
      multiSort: false,
    },
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
    addBidToState(state, data) {
      let object = state.bids;
      object.unshift(data);
      Vue.set(state, "bids", object);
    },
    removeBidFromState(state, id) {
      let bids = [];
      Object.entries(state.bids).forEach((item) => {
        if (Number(item[1].id) != Number(id)) {
          bids.push(item[1]);
        }
      });
      state.itemsTotalCount--;
      Vue.set(state, "bids", bids);
    },
    updateBidInState(state, data) {
      let existsAtIndex = state.bids.findIndex(u => u.id === data.id)
      if (existsAtIndex !== -1) {
        state.bids[existsAtIndex] = data
      }
      //Clone the array to trigger a UI update
      state.bids = [...state.bids]
    }
  },
  actions: {
    async restore({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .put(this._vm.$apiURL + "/bids/" + payload.id + "/restore")
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          return response.data.data;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async store({ commit, state, dispatch }, payload) {
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .post(this._vm.$apiURL + "/bids", payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          if (response.data.new.id > 0) {
            commit("addBidToState", response.data.new);
          }
          return response.data.new;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async getList({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return axios
        .get(this._vm.$apiURL + "/bids", {
          params: {
            find_string: state.search,
            stages: state.stagesForSearch,
            page: state.tableOptions.page,
            itemsPerPage: state.tableOptions.itemsPerPage,
            sortBy: state.tableOptions.sortBy[0],
            sortDesc: state.tableOptions.sortDesc[0],
          },
        })
        .then((response) => {
          updateField(state, {
            path: "itemsTotalCount",
            value: parseInt(response.data.total),
          });
          updateField(state, { path: "bids", value: response.data.data });
          updateField(state, {
            path: "tableOptions.page",
            value: parseInt(response.data.current_page),
          });
          updateField(state, {
            path: "tableOptions.last_page",
            value: parseInt(response.data.last_page),
          });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async getForPeriod({ commit, state, dispatch }) {
      if (!state.period.from || !state.period.to) return;
      updateField(state, { path: "fetched", value: false });
      return axios
        .get(this._vm.$apiURL + "/bids", {
          params: {
            fromDate: state.period.from,
            toDate: state.period.to,
            stages: -1
          },
        })
        .then((response) => {
          updateField(state, { path: "bids", value: response.data.data });
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async createCustomerAndCar({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return axios
        .patch(
          this._vm.$apiURL + "/bids/" + payload.id + "/create-customer-and-car",
          {}
        )
        .then((response) => {
          return true;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    remove({ commit, state, dispatch }, payload) {
      this._vm
        .$confirm({
          title: this._vm.i18n.t("common.confirm"),
          text: this._vm.i18n.t("common.confirm_remove"),
          cancelText: this._vm.i18n.t("common.no"),
          acceptText: this._vm.i18n.t("common.yes"),
        })
        .then((y) => {
          return axios
            .delete(this._vm.$apiURL + "/bids/" + payload.id)
            .then((response) => {
              if (response.data.status === "success") {
                commit("removeBidFromState", payload.id);
                this._vm.$inform(this._vm.i18n.t("common.success_remove"));
              }
            })
            .catch((error) => {
              dispatch("common/showError", { error: error }, { root: true });
            });
        })
        .catch((n) => {});
    },
    async update({ commit, state, dispatch }, payload) {
      updateField(state, { path: "nowProcessingBidWithId", value: payload.id });
      updateField(state, { path: "savingInProgress", value: true });
      return await axios
        .put(this._vm.$apiURL + "/bids/" + payload.id, payload)
        .then((response) => {
          if(response.data && response.data.status === "success" && response.data.updated) {
            this._vm.$inform(this._vm.i18n.t("common.operation_success"));
            commit('updateBidInState', response.data.updated)
          }
          return response.data.updated;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
          return false;
        })
        .finally(() => {
          updateField(state, { path: "nowProcessingBidWithId", value: null });
          updateField(state, { path: "savingInProgress", value: false });
        });
    },
    async getBid({ commit, state, dispatch }, payload){
      updateField(state, { path: "nowProcessingBidWithId", value: payload });
      return axios
          .get(this._vm.$apiURL + "/bids/"+payload)
          .then((response) => {
            updateField(state, { path: "bid", value: response.data.bid });
          })
          .catch((error) => {
            dispatch("common/showError", { error: error }, { root: true });
          })
          .finally(() => {
            updateField(state, { path: "nowProcessingBidWithId", value: null });
          });
    }
  },
}
